import { 
	ActionService,
	TaskService 
} from 'phoenix/services';
import { PhoenixTask } from 'phoenix/domain';
import { Task, TrackableTask } from 'sharebase/domain';
import { TrackingService, EventDetails } from 'sharebase/services';

export class TaskFactory {
	public static $inject = [
		'pxActionService',
		'sbTrackingService',
		'pxTaskService',
		'gettextCatalog'
	];

	constructor(
		private readonly pxActionService: ActionService,
		private readonly sbTrackingService: TrackingService,
		private readonly pxTaskService: TaskService
	) {}

    public trackTaskEvent(action:string, label = '') {
        let eventDetails:EventDetails = {
            'category': 'task',
            'action': action,
            'label': label
        }

        this.sbTrackingService.pushAnalyticsEvent('trackableEvent', eventDetails);
    }

	public create(pxTask?: PhoenixTask) {
		return new TrackableTask(pxTask, this.pxActionService, this.sbTrackingService, this, this.pxTaskService);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/taskFactory.ts